module.exports = __webpack_public_path__ + "5d0c27f410cf91d82d34dd9320c8894b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/loop-button-note.png
// module id = 45
// module chunks = 0